import React from 'react';
import {
  Route, Switch,
} from 'react-router-dom';
import BNPLPage from '../../pages/bnpl';

export default function BnplRoutes() {
  return (
    <Route
      render={
        ({ location }) => (
          <Switch location={location}>
            <Route exact path="/bnpl" component={BNPLPage} />
          </Switch>
        )
      }
    />
  );
}
